module.exports = __webpack_public_path__ + "static/media/cow.34d26663.png";